var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66671 5.33337L6.66706 6.49834e-05L5.66706 0L5.66671 5.33337H0V6.33337H5.66665L5.66628 11.9997L6.66628 11.9998L6.66664 6.33337H12V5.33337H6.66671Z",
  fill: "currentColor"
})));
export { SvgPlus as ReactComponent };
export default new URL("/home/runner/_work/motorway-dealer-webapp/motorway-dealer-webapp/components/Gallery/icons/plus.svg", import.meta.url).toString();